<template>
  <div class="links-page">
      <div><a href="https://bit.ly/myanmarspring22222">Realtime Statistics of
      Fallen Protestors</a></div>
      <div>
      <a
      href="https://www.aljazeera.com/news/2021/2/23/timeline-of-events-in-myanmar-since-february-1-coup?fbclid=IwAR24uLLDxkS-aFcU6kHOCId4Knbc-vfq_RMLq79D3HGyaFZ1PA5KjCKe6kA">Timeline
      of events in Myanmar by Aljazeera</a>
      </div>
      <div>
      <a href="https://nwayooheroes.org/">Nwayoo Heroes: trust fund for families
      of deceased protestors</a>
      </div>
      <div>
      <a href="https://www.yangon.design/home">Yangon Design: Protest Posters by
      Myanmar Graphic Designers</a>
      </div>



  </div>
</template>

<script>
export default {};
</script>

<style>
.links-page {
  position: relative;
  z-index: 2;
  padding: 12vh 5vw;
}

.links-page >div> a {
    color: white;
    font-size: 1.25em;
}
.links-page > div {
    padding: 2vh 0;
}
</style>